import { SyntheticEvent, forwardRef, useEffect, useImperativeHandle, useState } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { getBrand, createBrand } from "../../../redux/brandSlice";
import { useDispatch, useSelector } from "react-redux";
import { Button, FormControl, FormControlLabel, IconButton, MenuItem, Radio, RadioGroup, TextField } from "@mui/material";
import React from "react";
import { Brand } from "../../../model/brand.model";
import { BrandsService } from "../../../service/brands.service";
//import { isNumber } from "lodash";
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import ArrowUpwardRoundedIcon from '@mui/icons-material/ArrowUpwardRounded';
import ClearOutlinedIcon from '@mui/icons-material/ClearOutlined';
import { ToastContainer, toast } from "react-toastify";
import { CustomerService } from "../../../service/customers.service";
import { size } from "lodash";

const RetailAccountDetails = forwardRef((props: any, ref: any) => {

  useImperativeHandle(ref, () => ({
    log() {
      console.log("child function");
    }
  }));

  const params = useParams();
  const brandId = params.brandid;
  const dispatch = useDispatch();
  const { brand } = useSelector((state: any) => state.brandSlice);
  const navigate = useNavigate();
  const [picture, setPicture] = useState(null);
  const [imgData, setImgData] = useState<string[]>([]);
  const [status, setStatus] = useState(1);
  const [enterpriseName, setEnterpriseName] = useState("");
  
  const [userName, setUserName] = useState("");
  const [userRole,setUserRole] = useState("");
  const [mobileNo, setMobileNO] = useState("");
  const [EMailId,setEMailId] = useState("");
  const [enterpriseGST, setEnterpriseGST] = useState("");

  const [selectedUserId, setSelectedUserId] = React.useState("");
  const [availableBrands, setAvailableBrands] = useState<Brand[]>([]);
  const customerService = new CustomerService();

  const [brandImage, setbrandImage] = useState("");
  const [brandImageData, setbrandImageData] = useState("");
  const [errMsg, setErrMsg] = useState('');
  const [isedit, setIsEdit] = React.useState(true);
  const location = useLocation();




  let parameters = {}
  let iscalled = false;
  useEffect(() => {


    console.log("+++++++++++++++selectedBradId : " + props.empname)
    if (!iscalled) {
      iscalled = true

      /*id: person.entId,
      ein: person.EIN,
      name: person.entName,
      address: person.entAddress,
      branch: person.entBranch,
      gst: person.entGST,
      status: person.status,
      users: entUsers */


      // entID={enterpriseEIN}  entEIN={enterpriseEIN} entStatus={status}
      setSelectedUserId(props.retailUser.userId)
      setUserName(props.retailUser.username)
      setStatus(props.retailUser.status)
      setMobileNO(props.retailUser.mobileno)
      setEMailId(props.retailUser.email)
      
      setUserRole(props.retailUser.userrole)


      
    }
  }, []);

  const onChangePicture = (e: any) => {
    if (e.target.files[0]) {
      setPicture(e.target.files[0]);
      // setImgData(URL.createObjectURL(e.target.files[0]));
    }
  };


  const [submitClick, setsubmitClick] = React.useState(false);
  const changeUserStatus = () => {

    if (!/^[0-9]{10}$/.test(mobileNo)) {
      toast.error("Mobile number must be 10 digits", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 2500,
        hideProgressBar: true,
      });
      return;
    }

    customerService.updateRetailUser(selectedUserId, userName,mobileNo,EMailId, userRole,status).then((res: any) => {

      if (res != null) {
        if (res.status == 100) {
          toast.success("Updated Successfully !!!", {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 2000,
            hideProgressBar: true,
          });

          props.callback();
        } else {
          // surface the server reason (e.g. "Mobile number already registered to <name>")
          toast.error(res.msg ? res.msg : "Update Failed !!!", {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 3500,
            hideProgressBar: true,
          });

        }
      }

    }).catch((err: any) => {
      console.log('err ', err);
      setErrMsg('Something went wrong ');
    });

  }

  const onUploadBrandImg = (event: SyntheticEvent) => {
    const element = event.target as HTMLInputElement;
    if (element.files) {

      const file = element.files[0];
      console.log("^^^Cad^^^^^^^^^^^file : " + file.name);
      const reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = () => {

        setbrandImage(file.name);

        setbrandImageData(reader.result as string);

      }
      reader.onerror = (e) => { console.log('err') }
    }
  }

  return (
    <div className="">


      <div className="border p-3">

       


          <div className="col-md-6 text-left">
            <div className="form-group  font_size_13px mt-1">

              <TextField size="small" label="User Name" InputLabelProps={{ shrink: true }} InputProps={{ sx: { height: 30 }}}
                type="text" className="form-control" name='prodDispName' value={userName}
                error={submitClick}
                //  helperText={ (submitClick &&   (brandName == "" || brandName == null)) ? 'required*' : ""}


                onChange={(e: any) => {
                  setUserName(e.target.value)
                }}
              />
            </div>
          </div>

          <div className="col-md-6 text-left">
            <div className="form-group  mt-1">

              <TextField size="small" label="Mobile No" InputLabelProps={{ shrink: true }} InputProps={{ sx: { height: 30 }}}                 type="text" className="form-control" name='mobileNo' value={mobileNo}
                error={submitClick}
                helperText="10 digits — this is the user's login number"


                onChange={(e: any) => {
                  setMobileNO(e.target.value.replace(/[^0-9]/g, '').slice(0, 10))
                }}
              />
            </div>
          </div>

          <div className="col-md-6 text-left">
            <div className="form-group  font_size_13px mt-1">

              <TextField size="small" label="Emailid" InputLabelProps={{ shrink: true }} InputProps={{ sx: { height: 30 }}}
                type="text" className="form-control" name='emailId' value={EMailId}
                error={submitClick}
                //  helperText={ (submitClick &&   (brandName == "" || brandName == null)) ? 'required*' : ""}


                onChange={(e: any) => {
                  setEMailId(e.target.value)
                }}
              />
            </div>
          </div>

          <div className="col-md-8 text-left">
            <div className="form-group"  >
              <label className="mt-1 ml-1 pr-3">User Role</label>
            
              <FormControl className="" >
                <RadioGroup row name='UserRole' value={userRole} className="mt-0 p-0"
                  onChange={(e) => {
                    setUserRole(e.target.value)

                  }} >

                  
                  <FormControlLabel value="A" label="Admin" control={<Radio size="small" color="primary" />} />
                  <FormControlLabel value="E" label="Employee" control={<Radio size="small" color="secondary" />} />
                </RadioGroup>
              </FormControl>
            </div>
          </div>
          
          

          <div className="col-md-8 text-left">
            <div className="form-group"  >
            <label className="mt-1 ml-1 pr-5">Status</label>
              <FormControl className="" >
                <RadioGroup row name='status' value={status} className="mt-0 p-0"
                  onChange={(e) => {
                    setStatus(Number(e.target.value))

                  }} >

                  <FormControlLabel hidden value="-1" label="Pending" control={<Radio size="small" color="success" />} />
                  <FormControlLabel value="1" label="Activate" control={<Radio size="small" color="success" />} />
                  <FormControlLabel value="0" label="Deactive" control={<Radio size="small" color="error" />} />
                </RadioGroup>
              </FormControl>
            </div>
          </div>

          

         


          

        
      </div>
      <div className="col-12 text-right mt-3">
        {/* <Button  onClick={() => changeEntStatus()} >  */}

        <Button style={{ color: "green" }} className="mr-2" onClick={() => changeUserStatus()} variant="text" startIcon={<ArrowUpwardRoundedIcon />}>
          Submit
        </Button>

      </div>




    </div>
  );
})

export default RetailAccountDetails;
